// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ExtEnrollmentSiteEnrollmentModel } from './extEnrollmentSiteEnrollmentModel.js';
import type { TCSSource } from './tCSSource.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ExtEnrollmentMedBenClientIdentifiersModel {
    'sites': Array<ExtEnrollmentSiteEnrollmentModel>;
    'sourceId'?: TCSSource;
    'alternateId'?: string;
    'alternateIdType'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ExtEnrollmentMedBenClientIdentifiersModel>> = [
        {
            "name":     "sites",
            "baseName": "sites",
            "type":     "Array<ExtEnrollmentSiteEnrollmentModel>"
        },
        {
            "name":     "sourceId",
            "baseName": "sourceId",
            "type":     "TCSSource"
        },
        {
            "name":     "alternateId",
            "baseName": "alternateId",
            "type":     "string"
        },
        {
            "name":     "alternateIdType",
            "baseName": "alternateIdType",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return ExtEnrollmentMedBenClientIdentifiersModel.attributeTypeMap;
    }
}
